
<template v-if="showExtraContent">
  <div v-if="isNotificationBlockVisible" class="mb-6">
    <p>{{  $t('profile.successNotifications.description') }}</p>
    <ProfileNotifications v-if="notificationSettings" 
      translation-scope="profile.successNotifications"
      :settings="notificationSettings"
      :hideEnabled="true"
      :origin="props.origin"
    />
  </div>

  <BlogPreview />
</template>

<script setup lang="ts">
import { isLoggedIn } from "@/features/user/store";
import BlogPreview from "../blog/blog-preview.vue";
import ProfileNotifications from "../profile/profile-notifications.vue";
import { computed, onMounted, ref } from 'vue';
import { api } from '../../api';
import { NotificationSettings } from '../../types';

const notificationSettings = ref<NotificationSettings | null>(null);

const props = defineProps<{
  origin: string;
}>();

const isNotificationBlockVisible = computed(() => {
  if (!isLoggedIn.value) {
    return false;
  }

  return !notificationSettings.value?.newsletter || !notificationSettings.value?.reservation_reminder_email || !notificationSettings.value?.reservation_reminder_sms;
});

onMounted(async () => {
  if (isLoggedIn.value) {
    notificationSettings.value = await api.profile.getNotificationSettings();
  }
});
</script>